import React from "react";
import {Logo, MobileTopBar} from "peggirkit";
import logoLight from "@/assets/img/eataliano-logo-dark.svg";
import logoDark from "@/assets/img/eataliano-logo-light.svg";
import {IntlShape} from "react-intl";

const layoutMobileTopBar = (intl: IntlShape) => (
    <MobileTopBar
        containerClassname={"py-3"}
        burgerConfig={{title: open => intl.formatMessage({id: open ? "closeMenu" : "openMenu"})}}
        logo={
            <Logo
                centerAbsolutely={true}
                src={logoLight}
                darkSrc={logoDark}
                alt={intl.formatMessage({id: "appName"})}
            />
        }
        // endActions={
        //     <ActionRow>
        //         <ActionRowButton
        //             contentsClassname={"relative"}
        //             variant={"text"}
        //             color={"secondary"}
        //             buttonAction={{
        //                 as: "reactRouterLink",
        //                 actionProps: {
        //                     to: router.contactForms.absolutePath(),
        //                 },
        //             }}
        //             title={intl.formatMessage({id: "nUnreadContactForms"}, {n: 123})}
        //             iconBefore={<Icon icon={BellIcon}/>}
        //             iconAfter={<div className={"absolute top-1 -right-1.5"}>
        //                 <div className="relative flex h-2 w-2">
        //                     <div
        //                         className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"
        //                     >
        //                     </div>
        //                     <div className="relative inline-flex rounded-full h-2 w-2 bg-green-500"></div>
        //                 </div>
        //             </div>
        //             }
        //             iconOnly={false}
        //             borderRadius={"rounded-full"}
        //             buttonClassname={"-mr-2"}
        //             props={{
        //                 ...applyTooltip(intl.formatMessage({id: "nUnreadContactForms"}, {n: 123})),
        //             }}
        //         />
        //     </ActionRow>
        // }
    />
);

export default layoutMobileTopBar;